var UserInfoBuilder = /** @class */ (function () {
    function UserInfoBuilder() {
        this.userInfo = {
            ip: '88.119.150.196',
            userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_11_3) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/50.0.2661.102 Safari/537.36',
            operatingSystemFamily: 'OS X',
            operatingSystemName: 'OS X',
            operatingSystemVersion: '10.11.3',
            browserFamily: 'Chrome',
            browserName: 'Chrome',
            browserVersion: '50',
            netSpeed: 'Unknown',
            domain: 'zebra.lt',
            ispName: 'TEO LT',
            organization: 'TEO LT',
            city: 'Vilnius',
            regionName: 'Vilniaus Apskritis',
            postalCode: '01001',
            metroCode: '',
            areaCode: '',
            countryCode: 'LT',
            countryName: 'Lithuania',
            continentCode: 'EU',
            latitude: 54.6833,
            longitude: 25.3167,
            timezone: 'Europe/Vilnius',
            asNumber: 'AS8764 TEO LT, AB',
            ipUserType: 'residential'
        };
    }
    UserInfoBuilder.prototype.withIp = function (ip) {
        this.userInfo.ip = ip;
        return this;
    };
    UserInfoBuilder.prototype.withUserAgent = function (userAgent) {
        this.userInfo.userAgent = userAgent;
        return this;
    };
    UserInfoBuilder.prototype.withOperatingSystemFamily = function (operatingSystemFamily) {
        this.userInfo.operatingSystemFamily = operatingSystemFamily;
        return this;
    };
    UserInfoBuilder.prototype.withOperatingSystemName = function (operatingSystemName) {
        this.userInfo.operatingSystemName = operatingSystemName;
        return this;
    };
    UserInfoBuilder.prototype.withOperatingSystemVersion = function (operatingSystemVersion) {
        this.userInfo.operatingSystemVersion = operatingSystemVersion;
        return this;
    };
    UserInfoBuilder.prototype.withBrowserFamily = function (browserFamily) {
        this.userInfo.browserFamily = browserFamily;
        return this;
    };
    UserInfoBuilder.prototype.withBrowserName = function (browserName) {
        this.userInfo.browserName = browserName;
        return this;
    };
    UserInfoBuilder.prototype.withBrowserVersion = function (browserVersion) {
        this.userInfo.browserVersion = browserVersion;
        return this;
    };
    UserInfoBuilder.prototype.withNetSpeed = function (netSpeed) {
        this.userInfo.netSpeed = netSpeed;
        return this;
    };
    UserInfoBuilder.prototype.withDomain = function (domain) {
        this.userInfo.domain = domain;
        return this;
    };
    UserInfoBuilder.prototype.withIspName = function (ispName) {
        this.userInfo.ispName = ispName;
        return this;
    };
    UserInfoBuilder.prototype.withOrganization = function (organization) {
        this.userInfo.organization = organization;
        return this;
    };
    UserInfoBuilder.prototype.withCity = function (city) {
        this.userInfo.city = city;
        return this;
    };
    UserInfoBuilder.prototype.withRegionName = function (regionName) {
        this.userInfo.regionName = regionName;
        return this;
    };
    UserInfoBuilder.prototype.withPostalCode = function (postalCode) {
        this.userInfo.postalCode = postalCode;
        return this;
    };
    UserInfoBuilder.prototype.withMetroCode = function (metroCode) {
        this.userInfo.metroCode = metroCode;
        return this;
    };
    UserInfoBuilder.prototype.withAreaCode = function (areaCode) {
        this.userInfo.areaCode = areaCode;
        return this;
    };
    UserInfoBuilder.prototype.withCountryCode = function (countryCode) {
        this.userInfo.countryCode = countryCode;
        return this;
    };
    UserInfoBuilder.prototype.withCountryName = function (countryName) {
        this.userInfo.countryName = countryName;
        return this;
    };
    UserInfoBuilder.prototype.withContinentCode = function (continentCode) {
        this.userInfo.continentCode = continentCode;
        return this;
    };
    UserInfoBuilder.prototype.withLatitude = function (latitude) {
        this.userInfo.latitude = latitude;
        return this;
    };
    UserInfoBuilder.prototype.withLongitude = function (longitude) {
        this.userInfo.longitude = longitude;
        return this;
    };
    UserInfoBuilder.prototype.withTimezone = function (timezone) {
        this.userInfo.timezone = timezone;
        return this;
    };
    UserInfoBuilder.prototype.withAsNumber = function (asNumber) {
        this.userInfo.asNumber = asNumber;
        return this;
    };
    UserInfoBuilder.prototype.withIpUserType = function (ipUserType) {
        this.userInfo.ipUserType = ipUserType;
        return this;
    };
    UserInfoBuilder.prototype.withPermissionLevel = function (permissionLevel) {
        this.userInfo.permissionLevel = permissionLevel || undefined;
        return this;
    };
    UserInfoBuilder.prototype.build = function () {
        return this.userInfo;
    };
    return UserInfoBuilder;
}());
export { UserInfoBuilder };
//# sourceMappingURL=user-info.builder.js.map